import "./Beliefs.module.css";
import Header from "@/reusable_sections/Header";
import Doctrinal from "./sections/Doctrinal";
import DoctrinalCatalog from "./sections/DoctrinalCatalog";
import Actionbar from "./sections/Actionbar";
import Footer from "@/reusable_sections/Footer";
export default function BeliefsPage() {
  return <div>
      <Header />
      <Doctrinal />
      <Actionbar />
      <DoctrinalCatalog />
      <Footer />
    </div>;
}